import { useTheme } from "@emotion/react";
import { FormatListBulleted, GridView } from "@mui/icons-material";
import { useState } from "react"

export default function HomePageCompactViewToggle({isCompactView, setIsCompactView}) {
    const theme = useTheme();

    return <div className="flex gap-2">
        <FormatListBulleted
            style={{ color: isCompactView ? theme.palette.primary.main : "gray", cursor: "pointer" }} 
            onClick={() => setIsCompactView(true)}
            />
        <GridView
            style={{ color: !isCompactView ? theme.palette.primary.main : "gray", cursor: "pointer" }} 
            onClick={() => setIsCompactView(false)}
            />
    </div>
}